<template>
<div class="meal-detail">
  <Hero :imageUrl="meal.imageUrl" :title="meal.name" />

  <div class="detail-content-container">
    <div class="remove-link" @click="removeMeal" v-if="data.isPlanned">
      {{ $t('recipes.lblRemoveFromPlan') }}
    </div>

    <h4 class="section-title">
      Recipes
    </h4>
    <div v-for="recipe in meal.recipes">
      <MealCard :dish="recipe" :hideButton="true" @showDishDetails="showDishDetails(recipe)" />
    </div>
  </div>
</div>
</template>

<script>
import store from '@state/store';
import MealCard from '../MealCard/MealCard';
import Hero from '../Hero/Hero';
import {
  kitchenDrawerComputed,
  kitchenDrawerMethods,
  mealsComputed,
  mealsMethods,
  recipesComputed,
  recipesMethods,
  dishesMethods,
  planMethods,
  groceryListMethods,
} from '@state/helpers';

export default {
  components: {
    Hero,
    MealCard,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    data: {
      type: Object,
      required: true,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...kitchenDrawerComputed,
    ...mealsComputed,
    ...recipesComputed,
    meal() {
      return this.data;
    },
  },
  mounted() {},
  methods: {
    ...kitchenDrawerMethods,
    ...mealsMethods,
    ...recipesMethods,
    ...dishesMethods,
    ...planMethods,
    ...groceryListMethods,
    addMeal() {
      this.setDishToAdd({ mealId: this.meal.id, recipeId: null });
      this.keepNavStateButToggleDrawer();
    },
    async removeMeal() {
      const result = await this.removeDish(this.meal.dishId);
      if (result) {
        this.data.onRemove(this.meal.dishId);
        this.getCurrentPlanGrid().finally(() => {
          if (this.onTabletUp === undefined || this.onTabletUp) {
            return this.getGroceryList();
          }
        });
        this.navigateHigher();
      }
    },
    async showDishDetails(recipe) {
      if (this.data.isPlanned) {
        this.navigateDeeper({
          title: this.$t('lblRecipe'),
          component: 'RecipeDetail',
          data: {
            ...recipe,
            dishId: this.data.dishId,
            isPlanned: this.data.isPlanned,
            onRevision: this.data.onRevision,
            parentMealId: this.meal.id,
          },
        });
      } else {
        this.navigateDeeper({
          title: this.$t('lblRecipe'),
          component: 'RecipeDetail',
          data: recipe,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.meal-detail {
  @extend %scrollable-drawer-content;

  background-color: $color-plan-detail-bg;

  .detail-content-container {
    padding: 0 1.6rem 10rem;

    .section-title {
      margin: 2rem 0 1rem;
    }
  }

  .remove-link {
    color: $color-action;
    font-size: 1.5rem;
    font-weight: bold;
    margin: 2rem 0;
    text-align: center;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
